(function () {
    const REGIONS = {
        ID: { name: 'Indonesia', flag: '🇮🇩', currency: 'IDR', shopifyCountry: 'ID' },
        ASIA: { name: 'Asia', flag: '🌏', currency: 'IDR', shopifyCountry: 'SG' },
        EU: { name: 'Europe & UK', flag: '🇪🇺', currency: 'EUR', shopifyCountry: 'NL' },
        US: { name: 'USA & Canada', flag: '🇺🇸', currency: 'USD', shopifyCountry: 'US' },
        ROW: { name: 'Australia', flag: '🇦🇺', currency: 'AUD', shopifyCountry: 'AU' },
    };
    const COOKIE_NAME = 'user_region_preference'; // dipakai header/footer untuk currency/market display
    const COOKIE_DAYS = 365;

    const POPUP_COOKIE_NAME = 'country_popup_answered';
    const POPUP_COOKIE_DAYS = 365;

    // --- Cookie helpers ---
    function setCookie(name, value, days) {
        const expires = new Date();
        expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
        document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/;SameSite=Lax`;
    }

    function getCookie(name) {
        const nameEQ = name + '=';
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    // --- Manager: state & logic untuk region/currency, dipakai header & footer ---
    class CountrySelectorManager {
        constructor() {
            this.regions = REGIONS;
            this.instances = [];
        }

        register(instance) {
            this.instances.push(instance);
        }

        getCurrentRegion() {
            return getCookie(COOKIE_NAME) || sessionStorage.getItem('currentRegion') || 'ID';
        }

        syncStorage(regionCode) {
            const region = this.regions[regionCode];
            if (!region) return;
            setCookie(COOKIE_NAME, regionCode, COOKIE_DAYS);
            try {
                localStorage.setItem('selectedRegion', regionCode);
                localStorage.setItem('display_currency', region.currency);
            } catch (e) {
                sessionStorage.setItem('selectedRegion', regionCode);
            }
            document.body.setAttribute('data-region', regionCode);
            sessionStorage.setItem('currentRegion', regionCode);
        }

        broadcastRegion(regionCode, sourceInstance) {
            this.instances.forEach((inst) => {
                inst.setActiveRegion(regionCode);
                inst.closeDropdown();
            });
        }

        submitShopifyLocalizationForm(region) {
            const nativeForms = document.querySelectorAll('localization-form form[action="/localization"]');
            for (const form of nativeForms) {
                const countryInput = form.querySelector('input[name="country_code"]');
                if (countryInput) {
                    countryInput.value = region.shopifyCountry;
                    form.submit();
                    return true;
                }
            }
            const fallbackForms = document.querySelectorAll('form');
            for (const form of fallbackForms) {
                const countryInput = form.querySelector('input[name="country_code"]');
                if (!countryInput) continue;
                countryInput.value = region.shopifyCountry;
                const currencyInput = form.querySelector('input[name="currency_code"]');
                if (currencyInput) currencyInput.value = region.currency;
                form.submit();
                return true;
            }
            return false;
        }

        selectRegion(regionCode, sourceInstance) {
            const region = this.regions[regionCode];
            if (!region) return;

            this.syncStorage(regionCode);
            this.broadcastRegion(regionCode, sourceInstance);

            const submitted = this.submitShopifyLocalizationForm(region);
            if (!submitted) {
                console.warn(
                    '[CountrySelector] Form /localization tidak ditemukan di halaman. ' +
                    'Market Shopify tidak berubah — cek apakah snippet localization ter-render di header/footer.'
                );
                window.location.reload();
            }
        }
    }

    // --- Instance: satu trigger dropdown fisik (header ATAU footer) — TIDAK diubah ---
    class CountrySelectorInstance {
        constructor(manager, config) {
            this.manager = manager;
            this.config = config;
            this._selecting = false;
            this._onOutsideClick = null;
            this._onEsc = null;
            this.init();
        }

        init() {
            this.overlay = document.getElementById(this.config.overlayId);
            this.trigger = document.getElementById(this.config.triggerId);
            this.popup = document.getElementById(this.config.popupId);
            if (!this.overlay || !this.trigger || !this.popup) return;

            const activeOption =
                this.popup.querySelector(`.${this.config.optionClass}.${this.config.activeClass}`) ||
                this.popup.querySelector(`.${this.config.optionClass}`);
            const activeRegion = activeOption ? activeOption.getAttribute('data-region') : 'ID';

            this.manager.syncStorage(activeRegion);
            this.renderTrigger(activeOption);
            this.addEventListeners();
            this.manager.register(this);
        }

        setActiveRegion(regionCode) {
            if (!this.popup) return;
            const options = this.popup.querySelectorAll(`.${this.config.optionClass}`);
            let matchedOption = null;
            options.forEach((opt) => {
                const isMatch = opt.getAttribute('data-region') === regionCode;
                opt.classList.toggle(this.config.activeClass, isMatch);
                opt.setAttribute('aria-selected', isMatch ? 'true' : 'false');
                if (isMatch) matchedOption = opt;
            });
            this.renderTrigger(matchedOption);
        }

        renderTrigger(option) {
            if (!option || !this.trigger) return;
            const flagEl = this.trigger.querySelector('[data-trigger-flag]');
            const codeEl = this.trigger.querySelector('[data-trigger-code]');
            const currencyEl = this.trigger.querySelector('[data-trigger-currency]');
            if (!flagEl && !codeEl && !currencyEl) return;

            const flagSourceEl = option.querySelector('.country-flag-header, .country-flag-footer');
            if (flagEl && flagSourceEl) {
                flagEl.innerHTML = flagSourceEl.innerHTML;
            }
            if (codeEl) codeEl.textContent = option.getAttribute('data-code') || option.getAttribute('data-region');
            if (currencyEl) currencyEl.textContent = `(${option.getAttribute('data-currency') || ''})`;
        }

        openDropdown() {
            this.overlay.classList.add(this.config.openClass);
            this.trigger.setAttribute('aria-expanded', 'true');

            this._onOutsideClick = (e) => {
                if (!this.overlay.contains(e.target)) this.closeDropdown();
            };
            document.addEventListener('click', this._onOutsideClick);

            this._onEsc = (e) => {
                if (e.key === 'Escape') this.closeDropdown();
            };
            document.addEventListener('keydown', this._onEsc);
        }

        closeDropdown() {
            this.overlay.classList.remove(this.config.openClass);
            this.trigger.setAttribute('aria-expanded', 'false');
            if (this._onOutsideClick) {
                document.removeEventListener('click', this._onOutsideClick);
                this._onOutsideClick = null;
            }
            if (this._onEsc) {
                document.removeEventListener('keydown', this._onEsc);
                this._onEsc = null;
            }
        }

        openPopup() {
            this.openDropdown();
        }

        addEventListeners() {
            this.trigger.addEventListener('click', (e) => {
                e.stopPropagation();
                if (this.overlay.classList.contains(this.config.openClass)) {
                    this.closeDropdown();
                } else {
                    this.openDropdown();
                }
            });

            const options = this.popup.querySelectorAll(`.${this.config.optionClass}`);
            options.forEach((option) => {
                option.addEventListener('click', (e) => {
                    if (this._selecting) return;
                    this._selecting = true;
                    const regionCode = e.currentTarget.getAttribute('data-region');
                    this.manager.selectRegion(regionCode, this);
                    setTimeout(() => {
                        this._selecting = false;
                    }, 500);
                });
            });
        }
    }

    // --- AutoPopup: independen dari header/footer, dan sekarang SELF-HEALING —
    //     kalau markup #countrySelector / #country-selector-popup tidak ditemukan
    //     di DOM (seperti kasus kamu: overlay/popup keduanya null), popup akan
    //     dibuat otomatis lewat JS (fallback), jadi tidak lagi bergantung pada
    //     apakah snippet Liquid sudah ditambahkan atau belum. ---
    class CountrySelectorAutoPopup {
        constructor(manager) {
            this.manager = manager;
            this._selecting = false;
            this._onEsc = null;
            this._onOutsideClick = null;
            this.overlayId = 'countrySelector';
            this.popupId = 'country-selector-popup';
            this.optionClass = 'country-option';
            this.init();
        }

        init() {
            // Sudah dijawab sebelumnya? jangan tampilkan apapun.
            const alreadyAnswered = !!getCookie(POPUP_COOKIE_NAME);
            if (alreadyAnswered) return;

            this.overlay = document.getElementById(this.overlayId);
            this.popup = document.getElementById(this.popupId);

            // FALLBACK: markup tidak ditemukan di DOM (kasus kamu sekarang) —
            // buat elemen popup sendiri lewat JS, sama seperti versi original.
            if (!this.overlay || !this.popup) {
                console.warn(
                    '[CountrySelectorAutoPopup] Markup #countrySelector / #country-selector-popup ' +
                    'tidak ditemukan di DOM. Membuat popup secara dinamis via JS sebagai fallback. ' +
                    'Cek Liquid theme kalau ingin popup ini di-render server-side.'
                );
                this.buildFallbackMarkup();
            }

            this.addEventListeners();
            this.manager.register(this);

            setTimeout(() => {
                this.overlay.classList.add('show');
            }, 100);
        }

        buildFallbackMarkup() {
            const overlay = document.createElement('div');
            overlay.className = 'country-selector-overlay';
            overlay.id = this.overlayId;

            const popup = document.createElement('div');
            popup.className = 'country-selector-popup';
            popup.id = this.popupId;

            popup.innerHTML = `
                <div class="country-selector-header">
                    <h2>Choose Your Region</h2>
                </div>
                <div class="country-selector-options">
                    ${Object.entries(this.manager.regions)
                      .map(
                        ([code, region]) => `
                        <button class="${this.optionClass}" data-region="${code}">
                            <span class="country-flag">${region.flag}</span>
                            <span class="country-name">${region.name.toUpperCase()}</span>
                        </button>
                    `
                      )
                      .join('')}
                </div>
                <div class="country-selector-footer">
                    <p>We use cookies to remember your choice.</p>
                </div>
            `;

            overlay.appendChild(popup);
            document.body.appendChild(overlay);

            this.overlay = overlay;
            this.popup = popup;
        }

        addEventListeners() {
            const options = this.popup.querySelectorAll(`.${this.optionClass}`);
            options.forEach((option) => {
                option.addEventListener(
                    'click',
                    (e) => {
                        if (this._selecting) return;
                        this._selecting = true;
                        const regionCode = e.currentTarget.getAttribute('data-region');
                        this.selectRegion(regionCode);
                        setTimeout(() => {
                            this._selecting = false;
                        }, 500);
                    },
                    { once: true }
                );
            });

            this._onOutsideClick = (e) => {
                if (e.target === this.overlay) this.closeDropdown();
            };
            this.overlay.addEventListener('click', this._onOutsideClick);

            this._onEsc = (e) => {
                if (e.key === 'Escape') this.closeDropdown();
            };
            document.addEventListener('keydown', this._onEsc);
        }

        selectRegion(regionCode) {
            this.manager.selectRegion(regionCode, this);
            setCookie(POPUP_COOKIE_NAME, '1', POPUP_COOKIE_DAYS);
        }

        setActiveRegion(regionCode) {
            setCookie(POPUP_COOKIE_NAME, '1', POPUP_COOKIE_DAYS);
        }

        closeDropdown() {
            if (!this.overlay) return;
            this.overlay.classList.add('hide');
            setTimeout(() => {
                if (this.overlay) this.overlay.remove();
            }, 300);
            if (this._onEsc) {
                document.removeEventListener('keydown', this._onEsc);
                this._onEsc = null;
            }
            if (this._onOutsideClick) {
                this.overlay.removeEventListener('click', this._onOutsideClick);
                this._onOutsideClick = null;
            }
        }
    }

    function boot() {
        if (window.countrySelectorManager) return;

        const manager = new CountrySelectorManager();
        window.countrySelectorManager = manager;

        window.countrySelectorHeader = new CountrySelectorInstance(manager, {
            overlayId: 'countrySelectorHeader',
            triggerId: 'countrySelectorTriggerHeader',
            popupId: 'countrySelectorPopupHeader',
            optionClass: 'country-option-header',
            activeClass: 'is-active-header',
            openClass: 'is-open-header',
        });

        window.countrySelectorFooter = new CountrySelectorInstance(manager, {
            overlayId: 'countrySelectorFooter',
            triggerId: 'countrySelectorTriggerFooter',
            popupId: 'countrySelectorPopupFooter',
            optionClass: 'country-option-footer',
            activeClass: 'is-active-footer',
            openClass: 'is-open-footer',
        });

        window.countrySelectorAuto = new CountrySelectorAutoPopup(manager);

        window.countrySelector = window.countrySelectorFooter;
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
        boot();
    }

    if (typeof module !== 'undefined' && module.exports) {
        module.exports = { CountrySelectorManager, CountrySelectorInstance, CountrySelectorAutoPopup };
    }
})();